import { useEffect, useMemo, useState } from "react";
import "./DesktopLogin.css";
import { authApi } from "../../../api";
import { useLang } from "../../../i18n/LangContext";

const FALLBACK = {
  eyebrow: "FORGOT PASSWORD",
  title: "Reset your password",
  subtitle: "Enter your account email to receive a reset link.",
  emailLabel: "Email",
  emailPlaceholder: "you@example.com",
  submit: "Send reset link",
  success: "If that email exists, a reset link has been sent.",
  error: "Unable to send reset email.",
  missing: "Please enter your email.",
};

export default function DesktopForgotPassword({ open, onClose = () => {} }) {
  const { t } = useLang();
  const copy = useMemo(() => t.forgotPassword || FALLBACK, [t.forgotPassword]);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setEmail("");
    setStatus("");
    setError("");
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("");

    const trimmed = email.trim();
    if (!trimmed) {
      setError(copy.missing || FALLBACK.missing);
      return;
    }

    try {
      setLoading(true);
      await authApi.forgotPassword(trimmed);
      setStatus(copy.success || FALLBACK.success);
    } catch (err) {
      const message =
        err?.data?.statusText ||
        err?.data?.statusDesc ||
        err?.message ||
        copy.error ||
        FALLBACK.error;
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="desktop-login-overlay" role="dialog" aria-modal="true" onMouseDown={handleBackdrop}>
      <div className="desktop-login-card">
        <button
          type="button"
          className="desktop-login-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>

        <p className="desktop-login-eyebrow">{copy.eyebrow}</p>
        <h2 className="desktop-login-title">{copy.title}</h2>
        <p className="desktop-login-subtitle">{copy.subtitle}</p>

        <form className="desktop-login-form" onSubmit={handleSubmit}>
          <label className="desktop-login-field">
            <span>{copy.emailLabel}</span>
            <input
              type="email"
              name="email"
              placeholder={copy.emailPlaceholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </label>

          {(error || status) && (
            <div className={`desktop-login-status ${error ? "is-error" : "is-success"}`}>
              {error || status}
            </div>
          )}

          <button type="submit" className="desktop-login-submit" disabled={loading}>
            <span>{loading ? "..." : (copy.submit || FALLBACK.submit).toUpperCase()}</span>
          </button>
        </form>
      </div>
    </div>
  );
}
